import * as React from 'react';
import AppFooter from '../modules/views/AppFooter';
import CtaBand from '../modules/views/CtaBand';
import NavBar from '../modules/views/NavBar';
import withRoot from '../modules/withRoot';
import CaseCards from '../modules/views/CaseCards';
import { CARDS_OFFICE } from '../Const';
import PageMeta from '../modules/components/PageMeta';

function Index() {
  return (
    <React.Fragment>
      <PageMeta
        title="オフィス・店舗の施工事例"
        description="飯田建築のオフィス・店舗の施工事例。事務所・店舗・倉庫の新築と改修、防水工事などの実績を写真でご紹介します。"
        path="/case/office"
      />
      <NavBar />
      <CaseCards
        title={'オフィス・店舗'}
        eyebrow="Office"
        cards={CARDS_OFFICE}
        animation={'animate__animated animate__fadeInUp'}
        backHref="/case"
      />
      <CtaBand />
      <AppFooter />
    </React.Fragment>
  );
}

export default withRoot(Index);
